import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false

new Vue({
        router,
        store,
        render: h => h(App),
        mounted() {
            //Quan carreguem l'aplicació mirem si tenim dades guardades al localStorage, i si és així les gardem a "data" de l'store
            //store.dispatch('getStorage');
            console.log('carreguem state data... in mounted app (main.js)');
            store.dispatch('getStorage');
        },
}).$mount('#app')
